import { BannerViewImpl } from './bannerview';
import { BannerCSSStyleImpl } from './bannercss';
import { UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler, UIComponentProps } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { BannerDto } from '../../../../core/dto/banner/bannerdto';

export interface BannerComponentProps extends UIComponentProps
{
    listOfBannerDto: BannerDto[];
    onBannerClick(bannerDto: BannerDto): void;
}

export interface BannerComponentHandler extends UIComponentHandler
{
    onBannerClick(bannerDto: BannerDto): void;
}

export class BannerComponent extends UIComponentImpl<BannerComponentProps, UIComponentState, UIDataModel> 
implements BannerComponentHandler
{
    constructor(props: BannerComponentProps)
    {
        super(props);
    }

    componentDidMount()
    {
        // (this.getView() as BannerViewImpl).initilizeCarsousel();
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new BannerViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new BannerCSSStyleImpl(applicationContext);
    }

    onBannerClick(bannerDto: BannerDto): void 
    {
        this.props.onBannerClick(bannerDto);
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        if(feature === APIFeatures.PASSWORD_VALIDATION)
        {
            
        }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/banner/bannercomponent.tsx